import { NgModule } from '@angular/core';

import { AtxLocationService } from './services';

@NgModule({
    imports: [

    ],
    providers: [
        AtxLocationService,
        {
            provide: 'WindowLocation',
            multi: true,
            useValue: location,
        }
    ]
})

export class AtxLocationModule {}
